/**
 * Footprint of a mode
 * @returns "3ch" for a named and unnamed mode
 */
export function modeFootprint(item) {
  return `${item.channels.length}ch`
}

/**
 * Default mode name
 * @returns "Mode X" for named and unnamed mode
 */
export function defaultModeName(item) {
  return `Mode ${item._order + 1}`
}

/**
 * Short mode name
 * @returns
 * - "Foo" for a named mode
 * - "Mode X" for an unnamed mode
 */
export function shortModeName(item) {
  return item.name || 'Unnamed mode'
}

/**
 * Basse name for the mode
 * @returns
 * - "Mode X - Foo" for a named mode
 * - "Mode X" for an unnamed mode
 */
export function baseModeName(item) {
  const { name } = item
  return name ? `${defaultModeName(item)} - ${name}` : defaultModeName(item)
}

/**
 * Same name format as in report
 * @returns
 * - "Mode X - Foo (3ch)" for a named mode
 * - "Mode X (3ch)" for an unnamed mode
 */
function fullModeName(item) {
  return `${baseModeName(item)} (${modeFootprint(item)})`
}

function getName(item) {
  switch (item._type) {
    case 'ssl.profile':
      return item.name
    case 'ssl.mode':
      return fullModeName(item)
    case 'ssl.channel':
      return item.name
    case 'ssl.presetRange':
      return `Preset range ${item._order + 1}`
    case 'ssl.preset':
      return item.name
    default:
      return ''
  }
}

export default getName
